import request from '@/utils/request';

// 跟进记录列表
export function trackList(data) {
  return request({
    url: '/customer-follow-up/list',
    method: 'post',
    data
  });
}

// 添加跟进记录
export function addTrackRecord(data) {
  return request({
    url: '/customer-follow-up/create',
    method: 'post',
    data
  });
}

// 统计列表
export function countTrackList(data) {
  return request({
    url: '/customer-follow-up/count-list',
    method: 'post',
    data
  });
}

// 员工跟踪记录明显
export function operatorTrackList(data) {
  return request({
    url: '/customer-follow-up/operator-list',
    method: 'post',
    data
  });
}
